module.exports = __webpack_public_path__ + "img/table-6.c347e0ee.jpg";